import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export type HistoryValue = string | number | boolean | null;

export interface FinancialHistoryChange {
  field: string;
  label: string;
  before: HistoryValue;
  after: HistoryValue;
  kind: 'money' | 'value';
}

export interface FinancialHistoryEvent {
  id: string;
  changed_at: string;
  operation: 'INSERT' | 'UPDATE' | 'DELETE';
  entity: string;
  record_id: string;
  description: string | null;
  actor: { label: string; verified: boolean };
  source: string;
  request_id: string | null;
  operation_id: string | null;
  changes: FinancialHistoryChange[];
}

export interface FinancialHistoryPage {
  ok: boolean;
  lading_uuid: string;
  events: FinancialHistoryEvent[];
  next_cursor: string | null;
  coverage: string;
}

@Injectable({ providedIn: 'root' })
export class FinancialHistoryService {
  constructor(private readonly http: HttpClient) {}

  load(ladingUuid: string, cursor: string | null): Observable<FinancialHistoryPage> {
    let params = new HttpParams().set('lading_uuid', ladingUuid).set('limit', '50');
    if (cursor) params = params.set('cursor', cursor);
    return this.http.get<FinancialHistoryPage>('/api/work_orders/financial_history.php', { params });
  }
}
